package tools

fun String.trimOrNull(): String? {
    val s = trim()
    return if( s == "" ) null else s
}